export default "__VITE_ASSET__CzYSD8Jh__"